// Authorization.js
import React from "react";
import "./Authorization.css";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import { useLanguage } from "../../../../LanguageProvider";
import InputField from "../../../../components/InputField/InputField";

export default function Authorization({
  selectedAuthOption,
  basicAuth,
  handleChangeBasicAuth,
  bearerToken,
  handleBearerTokenChange,
  handleAuthOptionChange,
}) {
  const { getTranslation } = useLanguage();

  const authOptions = [
    { value: "no-auth", label: "No Auth" },
    { value: "basic-auth", label: "Basic Auth" },
    { value: "Bearer", label: "Bearer Auth" },
  ];

  return (
    <div className="api-auth-cointainer">
      <div className="api-auth-left-section">
        <div style={{ width: "100%", padding: "25px" }}>
          <Dropdown
            options={authOptions}
            onChange={handleAuthOptionChange}
            value={selectedAuthOption}
            style={{ width: "95%" }}
          />
        </div>
      </div>
      <div className="api-auth-right-section">
        {selectedAuthOption === "no-auth" && (
          <p className="no-auth-text">{getTranslation("noAuth")}</p>
        )}
        {selectedAuthOption === "basic-auth" && (
          <>
            <InputField
              style={{ width: "45%" }}
              placeholder={getTranslation("username")}
              value={basicAuth.username}
              onChange={handleChangeBasicAuth}
              name="username"
              autoComplete={false}
            />
            <InputField
              style={{ width: "45%" }}
              placeholder={getTranslation("password")}
              value={basicAuth.password}
              onChange={handleChangeBasicAuth}
              name="password"
              type="password"
              autoComplete={false}
            />
          </>
        )}
        {selectedAuthOption === "Bearer" && (
          <InputField
            style={{ width: "45%" }}
            placeholder={"Bearer Token"}
            value={bearerToken}
            onChange={handleBearerTokenChange}
          />
        )}
      </div>
    </div>
  );
}
